import { render, staticRenderFns } from "./terms-of-service.vue?vue&type=template&id=f77c551a&scoped=true&"
import script from "./terms-of-service.vue?vue&type=script&lang=ts&"
export * from "./terms-of-service.vue?vue&type=script&lang=ts&"
import style0 from "./terms-of-service.vue?vue&type=style&index=0&id=f77c551a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f77c551a",
  null
  
)

export default component.exports